export default "__VITE_ASSET__BVtbHbyZ__ 584w";